import { colors } from 'components/Library/theme'

export const CANTIDAD_MESES_GRAFICO = 6

export const OPCIONES = [
  'Datos básicos',
  'Acción principal',
  'Acción secundaria',
  'Colores',
  'Bordes',
  'Fuente',
  'Pagos',
  'Beneficios temp'
]

// #region Idiomas
export const ES = {
  value: 'ES',
  label: 'Español'
}

export const EN = {
  value: 'EN',
  label: 'English'
}

export const IDIOMAS = [ES, EN]
// #endregion

// #region Acciones
export const ACCION_CORREO = {
  value: 1,
  label: 'Registrar correo'
}
export const ACCION_DESPLAZARSE = {
  value: 2,
  label: 'Mover scroll'
}
export const ACCION_ENLACE = {
  value: 3,
  label: 'Abrir enlace'
}
export const ACCION_VIDEO = {
  value: 4,
  label: 'Abrir video'
}

export const ACCIONES = [ACCION_CORREO, ACCION_DESPLAZARSE, ACCION_ENLACE, ACCION_VIDEO]
// #endregion

// #region Estados

export const ESTADO_HABILITADO = {
  value: true,
  label: 'Habilitado'
}

export const ESTADO_DESHABILITADO = {
  value: false,
  label: 'Deshabilitado'
}

export const ESTADOS = [ESTADO_HABILITADO, ESTADO_DESHABILITADO]

// #endregion

// #region Secciones
export const SECCION_HERO = {
  value: 'hero',
  label: 'Hero'
}

export const SECCION_MAIN = {
  value: 'main',
  label: 'Principal'
}

export const SECCION_BENEFICIOS = {
  value: 'beneficios',
  label: 'Beneficios'
}

export const SECCION_TIMELINE = {
  value: 'timeline',
  label: 'Linea de tiempo'
}

export const SECCION_PLANES = {
  value: 'planes',
  label: 'Planes'
}

export const SECCION_FOOTER = {
  value: 'footer',
  label: 'Pie de página'
}

export const SECCIONES = [
  SECCION_HERO,
  SECCION_MAIN,
  SECCION_BENEFICIOS,
  SECCION_TIMELINE,
  SECCION_PLANES,
  SECCION_FOOTER
]
// #endregion

export const DATOS_PAGINA = {
  id: '0',
  url: '',
  estado: true,
  idiomas: [EN.value, ES.value],
  scripts: {
    gtag: ''
  },
  opciones: {
    ES: {
      titulo: '',
      descripcion: '',
      keywords: ''
    },
    EN: {
      titulo: '',
      descripcion: '',
      keywords: ''
    },
    colores: {
      primario: colors.primary,
      secundario: colors.secondary
    },
    borde: 2,
    fuente: {
      url: 'https://fonts.googleapis.com/css2?family=Poppins&display=swap',
      nombre: "'Poppins', sans-serif"
    },
    seccionPagos: true
  },
  productos: [
    {
      nombre: '',
      descripcion: '',
      precioUnitario: 0.0
    }
  ],
  secciones: {
    hero: {
      ES: {
        imagen:
          'https://firebasestorage.googleapis.com/v0/b/guanabanapp.appspot.com/o/hero.png?alt=media&token=f87431b4-2747-46b8-9995-fd41f325844a',
        texto: 'Encabezado'
      },
      EN: {
        imagen:
          'https://firebasestorage.googleapis.com/v0/b/guanabanapp.appspot.com/o/main.png?alt=media&token=c4ebb901-6b85-4d70-9332-e876915d2c22',
        texto: 'Header'
      }
    },
    main: {
      accion: 0,
      ES: {
        imagen:
          'https://firebasestorage.googleapis.com/v0/b/guanabanapp.appspot.com/o/main.png?alt=media&token=c4ebb901-6b85-4d70-9332-e876915d2c22',
        titulo: 'Título principal',
        texto: 'Texto principal',
        textoAccion: 'Botón principal',
        keyAccion: '',
        titulos: []
      },
      EN: {
        imagen:
          'https://firebasestorage.googleapis.com/v0/b/guanabanapp.appspot.com/o/main.png?alt=media&token=c4ebb901-6b85-4d70-9332-e876915d2c22',
        titulo: 'Main title',
        texto: 'Main text',
        textoAccion: 'Main button',
        keyAccion: '',
        titulos: []
      },
      imagen:
          'https://firebasestorage.googleapis.com/v0/b/guanabanapp.appspot.com/o/main.png?alt=media&token=c4ebb901-6b85-4d70-9332-e876915d2c22'
    },
    beneficios: {
      accion: 0,
      items: [
        {
          icono: '',
          ES: {
            descripcion: 'Descripción beneficio 1',
            titulo: 'Beneficio 1',
            keyAccion: ''
          },
          EN: {
            descripcion: 'Description benefit 1',
            titulo: 'Benefit 1',
            keyAccion: ''
          }
        },
        {
          icono: '',
          ES: {
            descripcion: 'Descripción beneficio 2',
            titulo: 'Beneficio 2',
            keyAccion: ''
          },
          EN: {
            descripcion: 'Description benefit 2',
            titulo: 'Benefit 2',
            keyAccion: ''
          }
        },
        {
          icono: '',
          ES: {
            descripcion: 'Descripción beneficio 3',
            titulo: 'Beneficio 3',
            keyAccion: ''
          },
          EN: {
            descripcion: 'Description benefit 3',
            titulo: 'Benefit 3',
            keyAccion: ''
          }
        }
      ]
    },
    timeline: {
      ES: {
        titulo: 'Proceso'
      },
      EN: {
        titulo: 'Process'
      },
      items: [
        {
          logo: '',
          ES: {
            titulo: 'Paso 1',
            descripcion: 'Descripción paso 1'
          },
          EN: {
            titulo: 'Step 1',
            descripcion: 'Description step 1'
          }
        },
        {
          logo: '',
          ES: {
            titulo: 'Paso 2',
            descripcion: 'Descripción paso 2'
          },
          EN: {
            titulo: 'Step 2',
            descripcion: 'Description step 2'
          }
        },
        {
          logo: '',
          ES: {
            titulo: 'Paso 3',
            descripcion: 'Descripción paso 3'
          },
          EN: {
            titulo: 'Step 3',
            descripcion: 'Description step 3'
          }
        }
      ]
    },
    planes: {
      ES: {
        titulo: 'Planes',
        descripcion: 'Descripción detallada de los planes'
      },
      EN: {
        titulo: 'Plans',
        descripcion: 'Detailed description of the plans'
      },
      items: [
        {
          precio: '$100',
          ES: {
            nombre: 'Plan 1',
            descripcion: 'Descripción plan 1'
          },
          EN: {
            nombre: 'Plan 1',
            descripcion: 'Description plan 1'
          }
        },
        {
          precio: '$200',
          ES: {
            nombre: 'Plan 2',
            descripcion: 'Descripción plan 2'
          },
          EN: {
            nombre: 'Plan 2',
            descripcion: 'Description plan 2'
          }
        },
        {
          precio: '$300',
          ES: {
            nombre: 'Plan 3',
            descripcion: 'Descripción plan 3'
          },
          EN: {
            nombre: 'Plan 3',
            descripcion: 'Description plan 3'
          }
        }
      ]
    },
    subhero: {
      imagen:
        'https://firebasestorage.googleapis.com/v0/b/guanabanapp.appspot.com/o/hero.png?alt=media&token=f87431b4-2747-46b8-9995-fd41f325844a',
      ES: {
        texto: 'Encabezado'
      },
      EN: {
        texto: 'Header'
      }
    },
    footer: {
      accion: 0,
      ES: {
        titulo: 'Pie de página',
        descripcion: 'Texto pie de página',
        textoAccion: 'Botón secundario',
        keyAccion: ''
      },
      EN: {
        titulo: 'Footer',
        descripcion: 'Footer text',
        textoAccion: 'Secondary button',
        keyAccion: ''
      }
    }
  }
}
